import type { UseQueryOptions } from "@tanstack/react-query"

export const allConsultantsTeamName = "All Consultants"
export const allCustomersTeamName = "All Customers"
export const allFinancialTeamName = "All Financial"
export const allQATeamName = "All QA"
export const allSitesTeamName = "All Sites"
export const allConsultantsWorkspaceName = allConsultantsTeamName
export const allCustomersWorkspaceName = allCustomersTeamName
export const allFinancialWorkspaceName = allFinancialTeamName
export const allQAWorkspaceName = allQATeamName
export const allSitesWorkspaceName = allSitesTeamName

export const consultantTeamNames = [allConsultantsWorkspaceName]
export const consultantWorkspaceNames = [...consultantTeamNames]

export interface UseSigmaServiceOptions<
  TOptions extends object = Record<string, unknown>,
  TApiQueryOptions extends object = Record<string, unknown>,
  TData = unknown,
  TError = unknown,
> {
  apiQueryOptions?: TApiQueryOptions
  options?: TOptions
  queryOptions?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">
}

export interface SigmaAccessToken {
  accessToken: string
  expiresIn: number
  refreshToken: string
  tokenType: string
}

export interface SigmaAccessTokenResponse {
  access_token: string
  expires_in: number
  refresh_token: string
  token_type: string
}

export interface SigmaPaginatedResponse<ResponseT> {
  entries: ResponseT[]
  hasMore?: boolean
  nextPage: string | null
  total?: number
}

export interface SigmaPaginationOptions {
  limit: number
  page: string
}

export type SigmaTeamVisibility = "public" | "private"

export interface SigmaTeam {
  createdAt: string
  createdBy: string
  description: string
  isArchived: boolean
  name: string
  teamId: string
  updatedAt: string
  updatedBy: string
  visibility: SigmaTeamVisibility
}

export interface SigmaWorkbook {
  createdAt: string
  createdBy: string
  id: string // We're adding id to the response, we shouldn't do this
  latestVersion: number
  name: string
  ownerId: string
  path: string // e.g. "Boyd", "Engineering", "ENVS"
  updatedAt: string
  updatedBy: string
  url: string
  workbookId: string
  workbookUrlId: string
}

export enum SigmaWorkbookId {
  "DataCompleteness" = "cc321f0f-aae2-4164-8562-2febc6f29538",
  "EnergyAndWaterUse" = "11b9fde4-7015-49a4-b2a9-07a33e1a9356",
  "EnergyAndWaterUseCoreSchema" = "595d360b-ab5c-428a-94f3-0af445189100",
  "FinancialOverview" = "82fd1b62-c7f7-4b9b-a7fc-d3cee0e3e06d",
  "GHGInventory" = "7619d9b8-4129-42a3-af35-45f1485b61c0",
  "OutlierMonitor" = "957deaac-51d1-4668-8131-91fc12339d7b",
  "ResourceSummary" = "711aca88-5d83-4260-92ff-dcca2470d3df",
  "SiteDetails" = "7ada6341-d516-4f9a-83e8-490ec5da4beb",
  "SiteInsights" = "a5842d93-e200-42f6-b989-8ba9d6982b07",
  "SiteOverview" = "d7c13542-592d-4d46-b2b8-eb3da31fbf62",
}

export const defaultSigmaPaginationOptions: SigmaPaginationOptions = {
  limit: 1000,
  page: "1",
}
